const SWITZERLAND_COUNTRY_CODE = "CH"
const LIECHTENSTEIN_COUNTRY_CODE = "LI"

const isValidCountry = (countryCode: string | undefined) =>
  !!countryCode && [SWITZERLAND_COUNTRY_CODE, LIECHTENSTEIN_COUNTRY_CODE].includes(countryCode)

export { isValidCountry, SWITZERLAND_COUNTRY_CODE }
